import React, { useState, useEffect } from "react";
import Button from "../modules/Button";
import downlogo from "../../Assets/svg/download icon.svg";
// import rightImg from "../../Assets/svg/form image.svg";
// import rightImg2 from "../../Assets/form image.png";
import rightImg from "../../Assets/svg/Student Application form image.svg";
import mba from "../../Assets/svg/mba logo.svg";
import eng from "../../Assets/svg/eng-logo2.svg";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { api } from "../../Services";
import { useDispatch, useSelector } from "react-redux";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { useNavigate } from 'react-router-dom';

function FormIntro() {
  const tokenData = useSelector((state) => state.tokens.tokens);
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const [points, setpoints] = useState([
    "You are required to submit all your documents on time. We will not be able to process your application if you fail to do so.",
    "Please ensure all your information is accurate as they will be verified later.",
    "You will be able to move to the next stage of your application process only after you complete your documentations duly at this stage.",
    "Information once submitted cannot be changed.",
  ]);
  const btnText = () => {
    return (
      <div className="btn-text">
        <img src={downlogo} alt="download" />
        <span>Download list as PDF</span>
      </div>
    );
  };
  const nextField = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/form");
navigate("/application/form");

  };
  const callDocs = async () => {
    try {
      const docs1 = await api.getDocuments(
        "application",
        tokenData.appId,
        tokenData.token
      );

      console.log(JSON.stringify(docs1));
      dispatch(addTokenInfo(["docs", docs1.data]));
    } catch (err) {
      console.log("err", err.data);
    }
  };
  useEffect(() => {
    setTimeout(() => callDocs(), 200);
  }, []);
  useEffect(() => {
    let url = window.location.href;
    let baseUrl = GetBaseUrl(url);

    const cleanedUrl = url.replace(/^https?:\/\/(www\.)?/, "");
    // setLink(cleanedUrl);
    if (!url.split("/")[2]) {
      if (tokenData.applicationStatus !== "Registered") {
        // window.location.replace(baseUrl + "/application/submitted-status");
        navigate("/application/submitted-status");

      }
    }
  }, []);
  return (
    <div className="form-div intro">
      <div className="title-div">
        {" "}
        <img src={[ "B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)? eng:mba} alt="mba" />
        <div className="form-title">
          Welcome to the
          <span>IDFC FIRST Bank {[ "B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)?   'Engineering':'MBA'} Scholarship Program</span>
        </div>
      </div>
      <div className="content intro">
        <div className="content-left  content-item">
          {/* <div className="left-title">Start Your Application</div> */}
          <div className="instructions">
            Welcome!, Great to see you getting started. However, here are a few
            important points for you to remember.
            <GetMap list={points} />
            Upon selection, you will find further instructions and steps here
            for next action.
            <span>Best of luck! 🍀</span>
          </div>
          {/* <div className="instructions">
            Keep the following documents handy:
            <GetMap
              list={[
                "Passport size photograph",
                "PAN card",
                "Aadhaar card",
                " Master’s Program Admission Letter",
              ]}
            />
          </div> */}
          <Button
            onClickHandler={() => nextField()}
            type={"contained"}
            value={"Start Application"}
          />
        </div>
        <div className="content-right content-item">
          <div className="content-image">
            <img src={rightImg} alt="initial img" />
          </div>
        </div>
      </div>
    </div>
  );
}
function GetMap({ list }) {
  return (
    <ul className="points">
      {list.map((item, index) => {
        return (
          <li className="point" key={index}>
            {item}
          </li>
        );
      })}
    </ul>
  );
}
export default FormIntro;
